import { ItemWrapper } from '@/src/components';
import CountWords from '@/src/components/CountWords/CountWords';
import Row from '@/src/components/Layouts/Row/Row';
import { useSingleImageEffect } from '@/src/components/Upload';
import { get, uniqBy } from 'lodash';
import React from 'react';
import { RangePicker } from 'src/components';
import { Form, Input, OriSelect } from 'src/components/Antd';
import Image from 'src/pages/ProductEditor/Components/Image/Image1';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { ECondition } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/CustomerEligibleCondition';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  i18nGet,
  replaceI18nVariables,
  handleOnGetStoreTimezoneUTC,
} from 'src/tools/tools';
import { generalFilterOptions } from 'src/tools/helper';

const Item = Form.Item;

const customerDatabaseName = 'customerDatabase';
const currencyName = 'currency';
const salesChannelName = 'salesChannels';
const voucherName = 'voucherNo';
const descriptionName = 'description';
const imageName = 'featureImage';

const BasicInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const timezoneInUTC = handleOnGetStoreTimezoneUTC();

  const {
    dbs,
    form,
    freeItemName,
    time,
    onTimeChang,
    timeError,
    customerConditionName,
    disabled,
  } = props;
  // const timeZone = useSelector(getTimezone()) || '';
  // console.log('time', time);
  return (
    <SectionWrapper
      title={getI18n('voucher.storeVoucherDetail.voucherBasicInformation')}
      //containerClassName={css.container}
    >
      <Section bottomBorder className={css.container}>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={`${getI18n(
                    'voucher.storeVoucherDetail.vouchertoCustomerDatabase',
                  )}*`}>
                  <Item
                    name={customerDatabaseName}
                    rules={[
                      {
                        required: true,
                        message: replaceI18nVariables(
                          getI18n('general.fieldisrequired'),
                          getI18n(
                            'voucher.storeVoucherDetail.vouchertoCustomerDatabase',
                          ),
                        ),
                      },
                    ]}>
                    <OriSelect
                      disabled={disabled}
                      size='large'
                      onChange={() => {
                        form.setFieldsValue({
                          [currencyName]: null,
                          [salesChannelName]: [],
                          [freeItemName]: {},
                          [customerConditionName]: {
                            conditionType: ECondition.Registered,
                            customerTags: [],
                            customers: [],
                            vouchers: [],
                            excludeVouchers: false,
                          },
                        });
                      }}>
                      {(dbs || []).map((i) => {
                        const { customerDatabaseUuid, customerDatabaseName } =
                          i;
                        return (
                          <OriSelect.Option
                            value={customerDatabaseUuid}
                            key={customerDatabaseUuid}>
                            {customerDatabaseName}
                          </OriSelect.Option>
                        );
                      })}
                    </OriSelect>
                  </Item>
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={`${getI18n(
                    'voucher.storeVoucherDetail.voucherCurrency',
                  )}*`}>
                  <Item
                    shouldUpdate={(p, c) => {
                      const pV = get(p, customerDatabaseName);
                      const cV = get(c, customerDatabaseName);
                      return pV !== cV;
                    }}>
                    {({ getFieldValue }) => {
                      const dbUuid = getFieldValue(customerDatabaseName);
                      const db = dbs.find(
                        (i) => i.customerDatabaseUuid === dbUuid,
                      );
                      const salesChannelCurrencies =
                        get(db, 'salesChannelCurrencies') || [];
                      const _c = salesChannelCurrencies.reduce((pre, now) => {
                        const { currency } = now;
                        if (!currency) {
                          return pre;
                        }
                        const code = get(currency, 'code');
                        const label = get(currency, 'label');
                        return [...pre, { value: code, label }];
                      }, []);
                      const currencies = uniqBy(_c, 'value');

                      if (!db) {
                        return (
                          <Item name={currencyName}>
                            <OriSelect
                              disabled={disabled}
                              size='large'
                              notFoundContent={getI18n(
                                'voucher.storeVoucherDetail.noavailableoption',
                              )}></OriSelect>
                          </Item>
                        );
                      } else {
                        return (
                          <Item
                            name={currencyName}
                            rules={[
                              {
                                required: true,
                                message: getI18n(
                                  'voucher.storeVoucherDetail.fieldvalidperiod',
                                ),
                              },
                            ]}>
                            <OriSelect
                              disabled={disabled}
                              size='large'
                              onChange={() => {
                                form.setFieldsValue({
                                  [salesChannelName]: [],
                                  [freeItemName]: {},
                                });
                              }}>
                              {currencies.map((i: any) => {
                                const { value, label } = i;
                                return (
                                  <OriSelect.Option value={value} key={value}>
                                    {label}
                                  </OriSelect.Option>
                                );
                              })}
                            </OriSelect>
                          </Item>
                        );
                      }
                    }}
                  </Item>
                </ItemWrapper>
              ),
            },
            {
              child: (
                <ItemWrapper
                  title={`${replaceI18nVariables(
                    getI18n(
                      'voucher.storeVoucherDetail.voucherStartandEndDate',
                    ),
                    timezoneInUTC,
                  )}*`} //timeZone
                  //id='StoreVoucherStartAndEndTime'
                >
                  <RangePicker
                    disabled={disabled}
                    id='StoreVoucherStartAndEndTime'
                    size='large'
                    error={{
                      hasError: timeError,
                      errorMsg: getI18n(
                        'voucher.storeVoucherDetail.fieldvalidperiod',
                      ),
                    }}
                    value={time}
                    onChange={onTimeChang}
                    occupiedRanges={[]}
                  />
                </ItemWrapper>
              ),
            },
          ]}
        />
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={`${getI18n('general.sider.salesChannel')}*`}>
                  <Item
                    shouldUpdate={(p, c) => {
                      const pV = get(p, currencyName);
                      const cV = get(c, currencyName);
                      return pV !== cV;
                    }}>
                    {({ getFieldValue }) => {
                      const dbUuid = getFieldValue(customerDatabaseName);
                      const currency = getFieldValue(currencyName);
                      const db = dbs.find(
                        (i) => i.customerDatabaseUuid === dbUuid,
                      );
                      const salesChannelCurrencies =
                        get(db, 'salesChannelCurrencies') || [];
                      const currencyMapSalesChannel =
                        salesChannelCurrencies.reduce((pre, now) => {
                          const { salesChannelUuid, salesChannelName } = now;
                          const currency = get(now, 'currency');
                          const code = get(currency, 'code');
                          if (!currency) {
                            return pre;
                          }
                          if (pre[code]) {
                            const _temp = pre[code] || [];
                            _temp.push({
                              value: salesChannelUuid,
                              label: salesChannelName,
                            });
                            return {
                              ...pre,
                              [code]: _temp,
                            };
                          } else {
                            return {
                              ...pre,
                              [code]: [
                                {
                                  value: salesChannelUuid,
                                  label: salesChannelName,
                                },
                              ],
                            };
                          }
                        }, []);
                      const salesChannels =
                        currencyMapSalesChannel[currency] || [];

                      if (!db) {
                        return (
                          <Item name={currencyName}>
                            <OriSelect
                              disabled={disabled}
                              mode='multiple'
                              size='large'
                              notFoundContent={getI18n(
                                'voucher.storeVoucherDetail.noavailableoption',
                              )}></OriSelect>
                          </Item>
                        );
                      } else {
                        return (
                          <Item
                            name={salesChannelName}
                            rules={[
                              {
                                required: true,
                                message: getI18n(
                                  'voucher.storeVoucherDetail.fieldselectrequired',
                                ),
                              },
                            ]}>
                            <OriSelect
                              disabled={disabled}
                              mode='multiple'
                              size='large'
                              onChange={(uuids) => {
                                const currentFreeItem =
                                  getFieldValue(freeItemName) || {};
                                const _currentFreeItem = uuids.reduce(
                                  (pre, now) => {
                                    if (currentFreeItem[now]) {
                                      return {
                                        ...pre,
                                        [now]: currentFreeItem[now],
                                      };
                                    }
                                    return {
                                      ...pre,
                                      [now]: {
                                        products: [],
                                        salesChannelUuid: now,
                                        quantities: [],
                                      },
                                    };
                                  },
                                  {},
                                );
                                form.setFieldsValue({
                                  [freeItemName]: _currentFreeItem,
                                });
                              }}
                              showSearch
                              filterOption={generalFilterOptions}
                              optionLabelProp='label'>
                              {salesChannels.map((i: any) => {
                                const { value, label } = i;
                                return (
                                  <OriSelect.Option
                                    value={value}
                                    key={value}
                                    label={label}>
                                    {label}
                                  </OriSelect.Option>
                                );
                              })}
                            </OriSelect>
                          </Item>
                        );
                      }
                    }}
                  </Item>
                </ItemWrapper>
              ),
            },
            {
              child: (
                <ItemWrapper
                  title={`${getI18n(
                    'voucher.storeVoucherList_config.voucherNo.',
                  )}*`}
                  rightPart={
                    <Item
                      shouldUpdate={(p, c) => {
                        const pV = get(p, voucherName);
                        const cV = get(c, voucherName);
                        return pV !== cV;
                      }}>
                      {({ getFieldValue }) => {
                        const word = getFieldValue(voucherName);
                        const count = (word || '').length;
                        return <CountWords count={count} allCount={40} />;
                      }}
                    </Item>
                  }
                  rightSubTitle={getI18n(
                    'voucher.storeVoucherDetail.forreportingpurpose',
                  )}>
                  <Input
                    disabled={disabled}
                    size='large'
                    maxLength={40}
                    formProps={{
                      name: voucherName,
                      rules: [
                        {
                          required: true,
                          message: getI18n(
                            'voucher.storeVoucherDetail.vouchernumberrequired',
                          ),
                        },
                        {
                          pattern: /^[A-Za-z0-9-]+$/,
                          message: getI18n('general.invalidformat'),
                        },
                      ],
                    }}
                  />
                </ItemWrapper>
              ),
            },
          ]}
        />
      </Section>
      <Section className={css.bottomSection}>
        <ItemWrapper
          rightSubTitle={getI18n(
            'voucher.storeVoucherDetail.displayonshopperend',
          )}
          rightPart={
            <Item
              shouldUpdate={(p, c) => {
                const pV = get(p, descriptionName);
                const cV = get(c, descriptionName);
                return pV !== cV;
              }}>
              {({ getFieldValue }) => {
                const word = getFieldValue(descriptionName);
                const count = (word || '').length;
                return <CountWords count={count} allCount={500} />;
              }}
            </Item>
          }
          title={`${getI18n(
            'voucher.storeVoucherDetail.voucherDescription',
          )}*`}>
          <Input
            disabled={disabled}
            size='large'
            maxLength={500}
            formProps={{
              name: descriptionName,
              rules: [
                {
                  required: true,
                  message: getI18n(
                    'voucher.storeVoucherDetail.vouchernumberrequired',
                  ),
                },
              ],
            }}
          />
        </ItemWrapper>

        <ItemWrapper
          title={`${getI18n('voucher.storeVoucherDetail.featureImage')}*`}
          rightSubTitle={getI18n(
            'voucher.storeVoucherDetail.displayonshopperend',
          )}>
          <Item
            name={imageName}
            rules={[
              {
                required: true,
                message: getI18n(
                  'voucher.storeVoucherDetail.uploadimagerequired',
                ),
              },
            ]}>
            <_Image disabled={disabled} />
          </Item>
        </ItemWrapper>
      </Section>
    </SectionWrapper>
  );
};
export default BasicInfo;

const _Image = (props) => {
  const { value, onChange, id, disabled } = props;
  const [fileList, setFileList] = React.useState(value ? [value] : []);
  useSingleImageEffect(value, fileList, setFileList);
  const _onChange = (img) => {
    onChange(img);
  };
  return (
    // <ItemWrapper
    //   id={id}
    //   title='Feature Image*'
    //   rightSubTitle={
    //     'Display on shopper end. You may override on sales channel.'
    //   }>
    <div style={{ width: '100%' }} id={id}>
      <Image
        disabled={disabled}
        className={css.image}
        onChange={_onChange}
        fileList={fileList}
        setFileList={setFileList}
      />
    </div>

    // </ItemWrapper>
  );
};
